import { createSlice } from '@reduxjs/toolkit';

import { loadFiltersCase } from './cases/loadFilters';
import { resetGlobalsFiltersCase } from './cases/resetGlobalsFilters';
import { restoreFilterGroupCase } from './cases/restoreFilterGroup';
import { updateClientsMaintainerFiltersCase } from './cases/updateClientsMantainerFilters';
import { updateDocumentsFiltersCase } from './cases/updateDocumentsFilters';
import { updateGlobalsFiltersCase } from './cases/updateGlobalsFilters';
import { updateSalesAndPurchaseFiltersCase } from './cases/updateSalesAndPurchaseFilters';
import { updateSalesFiltersCase } from './cases/updateSalesFilters';
import { initialFilters } from './initialState';

const slice = createSlice({
  name: 'FilterGroup',
  initialState: initialFilters,
  reducers: {
    updateGlobalsFilters: updateGlobalsFiltersCase,
    updateSalesAndPurchaseFilters: updateSalesAndPurchaseFiltersCase,
    resetGlobalsFilters: resetGlobalsFiltersCase,
    loadFilters: loadFiltersCase,
    updateSalesFilters: updateSalesFiltersCase,
    updateDocumentsFilters: updateDocumentsFiltersCase,
    updateClientsMaintainerFilters: updateClientsMaintainerFiltersCase,
    restoreFilterGroup: restoreFilterGroupCase,
  },
});

const { reducer } = slice;

export const {
  updateGlobalsFilters,
  resetGlobalsFilters,
  updateSalesAndPurchaseFilters,
  loadFilters,
  updateSalesFilters,
  updateDocumentsFilters,
  updateClientsMaintainerFilters,
  restoreFilterGroup,
} = slice.actions;

export default reducer;
